import React, { Component } from 'react';
import Header from '../../../components/Header/Header';

// Import Style
import '../style.scss';
import chat from '../../../assets/images/chat.svg';
import line from '../../../assets/images/line.svg';


class ChatPage extends Component {
  render() {
    return (
      <div>
        <Header showHome={true} />
        <div className='chat_container'>
          <div className='chat_content'>
            <div className='chat_icon'>
              <img src={chat}></img>
            </div>
          </div>
          <div className='chat_content chat_text'>
            <h1 className='title'>Let's get the conversation going!</h1>
            <p>
              Have a question or need assistance? Start a chat with us now,
              <br />
              and we'll be happy to help you right away!
            </p>
            <div className='chat_line'>
              <img src={line}></img>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ChatPage;
